export default {
  SET_PROGRESS(state, progress) {
    state.progress = progress;
  },
};
